import styled from "@emotion/styled";
import { makeStyles } from "@mui/styles";
import { FormHelperText } from "@mui/material";

const getFieldBackground = (theme: any) =>
  theme.palette.mode === "dark" ? theme.colors.value_48 : theme.colors.value_01;

const getFieldTextColor = (theme: any) =>
  theme.palette.mode === "dark" ? theme.colors.value_27 : theme.colors.value_18;

const getOptionBackground = (theme: any) =>
  theme.palette.mode === "dark" ? theme.colors.value_21 : theme.colors.value_48;

export const useStyles = makeStyles((theme: any) => ({
  root: {
    margin: 0,

    "& .MuiSelect-select": {
      fontSize: "16px",
      color: getFieldTextColor(theme),
    },

    "& .MuiFormLabel-root": {
      color: theme.colors.value_11,
      fontSize: "1.2rem",
      transform: `translate(14px, ${theme.coefficient * 16.5}px) scale(1)`,
    },

    "& .MuiOutlinedInput-root": {
      borderRadius: 4,
      backgroundColor: getFieldBackground(theme),
      height: 40,
      width: "auto",
      fontSize: "1.4rem",
    },

    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.colors.value_32,
    },

    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.colors.value_05,
    },

    "&:hover :not(.Mui-error) .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.colors.value_05,
    },

    "& .MuiInputBase-root.MuiOutlinedInput-root": {
      paddingRight: `${theme.coefficient * 50}px !important`,
    },

    "& .MuiList-root": {
      padding: theme.coefficient * 8,
    },

    "& .MuiAutocomplete-listbox": {
      backgroundColor: getFieldBackground(theme),

      "& li": {
        color: getFieldTextColor(theme),
        fontSize: "1.4rem",
        padding: theme.coefficient * 8,
      },

      "& li:hover": {
        backgroundColor: getOptionBackground(theme),
      },

      '& li[aria-selected="true"]': {
        backgroundColor: getOptionBackground(theme),
        color: theme.colors.value_20,
        fontWeight: 500,
      },

      "& .MuiAutocomplete-option.Mui-disabled": {
        backgroundColor: theme.rgb.value_36,
        color: theme.colors.value_31,
        cursor: "not-allowed",
        opacity: 0.6,
      },
    },
  },

  regular_light_bg_var2: {
    "& .MuiOutlinedInput-root": {
      height: `${theme.coefficient * 36}px !important`,
      paddingRight: `${theme.coefficient * 40}px !important`,
      backgroundColor: getFieldBackground(theme),
    },

    "& .MuiOutlinedInput-notchedOutline": {
      borderWidth: `${theme.coefficient * 1}px`,
      borderColor: theme.colors.value_31,
    },

    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.colors.value_20,
    },

    "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.colors.value_35,
    },

    "& .MuiMenuItem-root": {
      color: getFieldTextColor(theme),
    },

    "& .MuiAutocomplete-option.Mui-disabled": {
      backgroundColor: theme.rgb.value_36,
      color: theme.colors.value_31,
      cursor: "not-allowed",
      opacity: 0.6,
    },
  },

  arrowIcon: {
    position: "absolute",
    right: (theme.coefficient * 7),
    top: (theme.coefficient * 7),
    width: (theme.coefficient * 24),
    height: (theme.coefficient * 24),
    backgroundImage: `url(${theme.images.arrow_down_var_1})`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundSize: "auto",
    opacity: 1,
    transition: "transform 0.2s ease",
    pointerEvents: "none",
    zIndex: 1,
  },

  arrowIconOpen: {
    transform: "rotate(180deg)",
  },
}));

export const Wrapper = styled.div`
    width: 100%;
`;

export const Label = styled.label`
    display: block;
    font-size: 1.4rem;
    line-height: 2rem;
    color: ${({ theme }) => theme.colors.value_31};
    font-weight: 500;
    margin-bottom: ${({ theme }) => theme.coefficient * 4}px;
`;

export const ErrorContainer = styled(FormHelperText)`
    color: ${({ theme }) => theme.colors.value_35}!important;
`;
